import { urlrefresh } from '@/lib/custom'
import { localStorageClear } from '@/lib/localStorageClear'

export const refreshToken = async () => {
  const siteUrl =
    process.env.NEXT_PUBLIC_WITHOUT_BASE_PATH === '0'
      ? `${process.env.NEXT_PUBLIC_SITEURL}/${process.env.NEXT_PUBLIC_SERVICE_NAME}`
      : `${process.env.NEXT_PUBLIC_SITEURL}`
  try {
    const response = await fetch(`${urlrefresh}`, {
      method: 'POST',
      headers: {
        'X-Raund-Token': `${process.env.NEXT_PUBLIC_RAUND_TOKEN}`,
        'X-Local': localStorage.getItem(`${process.env.NEXT_PUBLIC_SERVICE_NAME}_i18nextLng`),
      },
      body: JSON.stringify({
        refresh_token: localStorage.getItem(`${process.env.NEXT_PUBLIC_SERVICE_NAME}-refresh`),
        username: localStorage.getItem(`${process.env.NEXT_PUBLIC_SERVICE_NAME}-username`),
      }),
    })

    if (!response.ok) {
      const responseStatus = response.status
      // キャンペーン期間外の場合
      if (responseStatus === 400) {
        location.href = `${siteUrl}/`
      }
    }
    const res = await response.json()
    const result = res.result

    if (result.status === 200) {
      localStorage.setItem(`${process.env.NEXT_PUBLIC_SERVICE_NAME}-jwt`, result.id_token)
      location.reload()
    }

    if (result.status === 400 || result.status === 401 || result.status === 403) {
      localStorageClear()
      location.href = `${siteUrl}/auth/signin`
    }

    if (result.status === 500) {
      localStorageClear()
      location.href = `${siteUrl}/auth/signin`
    }
  } catch (error) {
    location.href = `${siteUrl}/auth/signin`
  }
}
